module.exports = __webpack_public_path__ + "img/mail.6c8c910c.svg";